import React from "react";
import { Box, Card, makeStyles } from "@material-ui/core";
import SectionTitleCollapse from "../SectionCollapse";

const useStyles = makeStyles((theme) => ({
  card: {
    padding: theme.spacing(2),
    margin: theme.spacing(1, 2.5),
  },
  container: {
    padding: theme.spacing(1, 0),
  },
}));

const ReportSummary = ({ disabled, loading, error, currentUser, children, timeout = 450 }) => {
  const classNames = useStyles();

  return (
    <SectionTitleCollapse
      in={!disabled}
      timeout={timeout}
    >
      <Card
        elevation={1}
        className={classNames.card}
      >
        <Box className={classNames.container}>{children}</Box>
      </Card>
    </SectionTitleCollapse>
  );
};

export default ReportSummary;
